import React from 'react';
import { GlowingEffect } from './border-effect/GlowingEffect';

const ServiceCard = ({ image, title, desc }) => {
  return (
    <div className="relative group rounded-lg bg-[#242424] lg:p-6 p-2 flex items-start lg:gap-4 gap-3 hover:shadow-md transition">
      <GlowingEffect
        blur={0}
        borderWidth={2}
        spread={80}
        glow={true}
        disabled={false}
        proximity={64}
        inactiveZone={0.01}
        className="opacity-0 group-hover:opacity-100 transition-opacity duration-300"
      />
      <img src={image} alt="Service Icon" className="relative z-10 mt-1 w-16 h-16 lg:w-[100px] lg:h-[100px]" />
      <div className="relative z-10 ml-2">
        <h3 className="text-body lg:mt-4 mt-2 font-dmsans font-medium lg:text-[24px] text-[#FFFFFF]">{title}</h3>
        <p className="text-body-sm lg:text-body font-normal font-roboto lg:mt-3 mt-1 text-[#9E9E9E]">{desc}</p>
      </div>
    </div>
  );
};

export default ServiceCard;
